import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { resetBuyMore, selectBuyMore } from '@app/redux/buyMore';
import { refetchBuyMoreHistory } from '@app/redux/buyMoreHistory';
import { selectConfig } from '@app/redux/config';
import { refetchUsage } from '@app/redux/plan';
import { postUsageMessage } from '@app/redux/utils';
import { EventTypes } from '@app/types';

import { Platform } from '@mfe/shared/schema-types';

import BrowseContainer from './browse/BrowseContainer';
import CheckoutContainer from './checkout/CheckoutContainer';
import { useModalContext } from './utils/hooks/useDialogType';
import { ErrorEnum, ModalType } from './utils/types';

const BuyMoreModal: React.FC = () => {
  const {
    dialogType,
    dialogTypeHandlers: { resetDialogType },
  } = useModalContext();

  const dispatch = useDispatch();
  const config = useSelector(selectConfig);

  const { isCheckout } = useSelector(selectBuyMore);
  const isModalOpen = dialogType === ModalType.BuyMore;
  const handleClose = React.useCallback(
    (isSuccess: boolean, error?: ErrorEnum) => {
      dispatch(resetBuyMore());

      resetDialogType();
      if (isSuccess || error === ErrorEnum.PURCHASE_TRANSACTION_ERROR) {
        dispatch(refetchUsage());
        dispatch(refetchBuyMoreHistory());
        if (config.platform !== Platform.Web) {
          dispatch(postUsageMessage({ eventType: EventTypes.RefetchPlanInfo }));
        }
      }
    },
    [config.platform, dispatch, resetDialogType]
  );

  const props = { isModalOpen, handleClose };

  if (dialogType !== ModalType.BuyMore) {
    return null;
  }

  return isCheckout ? <CheckoutContainer {...props} /> : <BrowseContainer {...props} />;
};

export default BuyMoreModal;
